import React from "react";
import ForgotPasswordOtpVerification from "../components/auth/otpVerification/ForgotPasswordOtpVerification";

const ForgotPasswordOtp = () => {
  return <ForgotPasswordOtpVerification />;
};

export default ForgotPasswordOtp;
